var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "black-text"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center",
    slot: "header"
  }, [_c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Logged Single Dispute")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "color": "black"
    }
  }, [_c('label', [_vm._v(" ShippingID :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    key: _vm.formKey,
    attrs: {
      "id": "AWB",
      "name": "awbnumber",
      "type": "text",
      "disabled": _vm.DisputeStatus !== null && _vm.DisputeStatus !== '',
      "placeholder": "Enter ShippingID"
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "color": "black"
    }
  }, [_c('label', [_vm._v("Shipment Type:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar-o'></i>"
    }
  }, [_c('Multiselect', {
    key: _vm.formKey,
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "DisputeStatus",
      "options": _vm.StatusTypeList,
      "placeholder": "Select Type",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.DisputeStatus),
      callback: function($$v) {
        _vm.DisputeStatus = $$v
      },
      expression: "DisputeStatus"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col')], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.searchResults(0)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), (_vm.editshowtable) ? _c('div', {
    staticClass: "card p-4 shadow-sm mt-4"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_c('b', [_vm._v("Search Result(" + _vm._s(_vm.totalcount) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending At")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Clientname")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount")])])])]), _vm._v(" "), (_vm.editshowtable) ? _c('tbody', [(_vm.totalcount === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-danger",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listUserData), function(data) {
    return _c('tr', {
      key: data.shippingid
    }, [_c('td', [_c('b-button', {
      staticClass: "d-flex align-items-center gap-1 px-1 py-0 custom-small-btn",
      attrs: {
        "size": "sm",
        "variant": "success"
      },
      on: {
        "click": function($event) {
          _vm.confirmShipment(data.shippingid, data.clientid, data.actionstatuscode)
        }
      }
    }, [_c('span', {
      staticClass: "d-flex align-items-center"
    }, [_vm._v("\n    Action\n  ")])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Buckettypename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastactionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.disputeamount))])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _vm._e()], 1)], 1)])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5709ab8c","hasScoped":true}!./src/views/components/loggedSingleDispute/loggedSingleDispute.component.html
// module id = 651
// module chunks = 1